module.exports = __webpack_public_path__ + "static/media/icon-left-dark-grey.c56055d8.svg";